import { useRouter } from 'next/router';
import { useMemo } from 'react';

import type { Menus } from '@kc-console/context';

/**
 * 현재 라우터 경로를 기준으로 해당 LNB 아이템이 선택된 상태인지 반환한다.
 */
export const useMenuActiveState = (currentMenu: Menus): boolean => {
  const router = useRouter();

  return useMemo(() => {
    const path = router.asPath.split('?')[0];

    if (!currentMenu) {
      return false;
    }

    if ((currentMenu.subMenus?.length ?? 0) > 0) {
      return false;
    }

    return path.startsWith(currentMenu.path);
  }, [currentMenu, router.asPath]);
};
